import { NgModule } from '@angular/core';
import { ProgressComponent } from './components/progress/progress.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FilesizePipe } from './pipes/filesize.pipe';
import { TruncNamePipe } from './pipes/trunc-name.pipe';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ApplicationService } from './services/application.service';
import { RouterModule } from '@angular/router';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { KendoLoadingComponent } from './components/kendo-loading/kendo-loading.component';
import { TabsComponent } from './components/tabstrip/tabs/tabs.component';
import { TabComponent } from './components/tabstrip/tab/tab.component';
import { SmartOverflowComponent } from './components/smart-overflow/smart-overflow.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { GeneralApiService } from './services/general-api.service';
import { SectionEditButtonComponent } from './components/section-edit-button/section-edit-button.component';
import { KendoTooltipComponent } from './components/kendo-tooltip/kendo-tooltip.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ItemOffersPipe } from './pipes/item-offers.pipe';
import { CustomTitleCasePipe } from './pipes/custom-title-case.pipe';
import { DialogBoxComponent } from './components/dialog-box/dialog-box.component';
import { DialogBoxViewImageComponent } from './components/dialog-box-view-image/dialog-box-view-image.component';
import { TimezonePickerComponent } from './components/timezone-picker/timezone-picker.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { CompareReceiptsComponent } from './components/dialog-receipt-compare/dialog-receipt-compare.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { sharedReducer } from './store/shared.actions';
import { initialSharedState } from './store/shared.state';
import { SharedEffects } from './store/shared.effects';
import { SharedStoreService } from './store/shared-store.service';
import { MultiInputValidatorDirective } from './directives/multi-input-validator.directive';
import { DropDownPopupComponent } from './components/dropdown-popup/dropdown-popup.component';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LineClampComponent } from './components/line-clamp/line-clamp.component';

@NgModule({
    declarations: [
        ProgressComponent,
        SpinnerComponent,
        FilesizePipe,
        TruncNamePipe,
        BreadcrumbComponent,
        ToggleSwitchComponent,
        KendoLoadingComponent,
        TabsComponent,
        TabComponent,
        SmartOverflowComponent,
        SectionEditButtonComponent,
        KendoTooltipComponent,
        ItemOffersPipe,
        CustomTitleCasePipe,
        DialogBoxComponent,
        DialogBoxViewImageComponent,
        TimezonePickerComponent,
        StatusIconComponent,
        CompareReceiptsComponent,
        MultiInputValidatorDirective,
        DropDownPopupComponent,
        LineClampComponent
    ],
    exports: [
        ProgressComponent,
        SpinnerComponent,
        FilesizePipe,
        TruncNamePipe,
        BreadcrumbComponent,
        ToggleSwitchComponent,
        KendoLoadingComponent,
        TabsComponent,
        TabComponent,
        SmartOverflowComponent,
        SectionEditButtonComponent,
        KendoTooltipComponent,
        ItemOffersPipe,
        CustomTitleCasePipe,
        DialogBoxComponent,
        DialogBoxViewImageComponent,
        TimezonePickerComponent,
        StatusIconComponent,
        CompareReceiptsComponent,
        MultiInputValidatorDirective,
        DropDownPopupComponent,
        LineClampComponent
    ],
    providers: [ApplicationService, GeneralApiService, SharedStoreService],
    imports: [
        CommonModule,
        RouterModule,
        PopupModule,
        FormsModule,
        ReactiveFormsModule,
        DropDownsModule,
        DateInputsModule,
        IntlModule,
        TooltipModule,
        IconsModule,
        IndicatorsModule,
        StoreModule.forFeature('shared', sharedReducer, {
            initialState: initialSharedState
        }),
        EffectsModule.forFeature([SharedEffects])
    ]
})
export class CoreModule {}
